<template>
  <div class="magezine">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/" style="display:flex;align-items:center">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item>Catalogue Entry</el-breadcrumb-item>
        <div style="display:flex;flex:1">
          <!-- <el-button type="primary" size="mini" @click="pullcatalog">Retrieve Catalogue data of Previous edition</el-button> -->
          <div  style="padding-top:10px;color:red;font-size:16px;margin-left:10px">Tips: CAC2025 will not provide print Catalogue, opting instead for online E-Catalogue. Please complete or update your information, then click the button below to save and submit.</div>
        </div>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="18">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="magezineForm" label-position="right" label-width="240px">
            <template v-for="(item,ind) in allList">
              <template v-if="item.fieldKey != 'clgCountry' && item.fieldKey != 'clgProvince'  && item.fieldKey != 'clgCity' && item.fieldKey != 'clgPdtType' && item.fieldKey != 'clgLogo' && item.fieldKey != 'clgIfShowEmail' ">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <template v-if="item.fieldKey == 'clgTel' || item.fieldKey == 'clgFax' ">
                    <el-input    v-model="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                </template>
                <template v-else>
                  <el-input v-if="item.fieldKey == 'clgIntro'" type="textarea"  v-model="form[item.fieldKey]" :placeholder="item.fieldHolder"  maxlength="500" show-word-limit></el-input>
                  <el-input v-else-if="item.fieldKey == 'clgEIntro'" type="textarea"  v-model="form[item.fieldKey]" :placeholder="item.fieldHolder"  maxlength="2000" show-word-limit></el-input>
                   <el-input v-else type="text"  v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" :disabled = 'item.fieldKey == "clgComName" || item.fieldKey == "clgComEName" '></el-input>
                </template>
                </el-form-item>
              </template>

              <!-- 主营产品 -->
              <template v-if="item.fieldKey == 'clgPdtType'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                    <el-cascader  v-model="form[item.fieldKey]" :options="tagOptions" :props="tagProps" separator="：" clearable  ></el-cascader>
                </el-form-item>
              </template>

              <template v-if="item.fieldKey == 'clgCountry'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" filterable :placeholder="item.fieldHolder" @change='changeCountry'>
                    <el-option v-for="(item, index) in countryList" :key="index" :label="item.zptCity" :value="item.zptECity"></el-option>
                  </el-select>
                </el-form-item>
              </template>
                <template v-if="item.fieldKey == 'clgProvince'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeProvince' :disabled="provinceList.length<=0">
                    <el-option v-for="(item, index) in provinceList" :key="index" :label="item.zptProvince" :value="item.zptProvince"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'clgCity'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey"  :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" :disabled="cityList.length<=0">
                    <el-option v-for="(item, index) in cityList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template v-if="item.fieldKey == 'clgLogo'">
                  <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind"  class="clgLogo">
                      <el-input v-model="form[item.fieldKey]" style="display:none"/>
                      <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]" />
                      <div style="color:red">Please upload a logo without white borders to ensure the best display.</div>
                  </el-form-item>
              </template> 
              <template v-if="item.fieldKey == 'clgIfShowEmail'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeCountry'>
                    <el-option label="YES" value="1"></el-option>
                    <el-option label="NO" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </template> 
          </template>
          <el-form-item>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit('1')" :disabled = 'Dsave'>Save as Draft</el-button>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit('')" :disabled = 'saveBtnStatue'>Submit</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-dialog
      title="Declaration of The Protection of Intellectual Property Rights"
      :visible.sync="dialogVisible"
      top='10vh'
      width="80%"
      :show-close='isClose'
      :close-on-click-modal='isClose'
      :close-on-press-escape='isClose'
      :modal-append-to-body='isClose'
      :append-to-body='isClose'
      :lock-scroll='isClose'>
      <div>
        <div class="tipContent">
          <div>In order to maintain the normal order of exhibition, enhance the awareness of intellectual property rights and protect the legitimate rights and interests of exhibitors, the organizing committee solemnly declares as follows according to the relevant provisions of the Trademark Law, Patent Law and Copyright Law of the People’s Republic of China:</div>
          <div>1. According to the Agreement on Trade-Related Aspects of Intellectual Property Rights of WTO, intellectual property rights include:① copyright and related rights; ② trademark rights; ③geographical indications; ④industrial design rights; ⑤ patents; ⑥ right of integrated circuit layout design (topology); ⑦ right to undisclosed information. Any unlawful exercise of the patents enjoyed by the intellectual property right holders for profit purpose, other unlawful acts causing damage to the business interests of the intellectual property right holders and all kinds of illegal acts infringing the moral rights of the intellectual property right holders are all infringements of intellectual property rights.</div>
          <div>2. The organizing committee attaches importance to, respects and protects the intellectual property rights of exhibitors. The organizing committee has the right to strengthen management, education, supervision and inspection of the exhibitors. The exhibitors shall enhance the awareness of intellectual property and make sure that the exhibits do not infringe the intellectual property rights of others.</div>
          <div>3. In order to create a good atmosphere and avoid unnecessary patent disputes, the organizing committee specially entrusts professional institutions to conduct patent screening on the products involved in the catalogue entries submitted by all the exhibitors. If the contents filled out by the exhibitors contain the risk of infringement, the committee will issue Patent warning for the exhibits to the exhibitors and handle the matters in the following ways:The names of the products in the catalogue involved in the risk of infringement shall be deleted;It is forbidden to advertise the products involved in the risk of infringement at the exhibition site. Otherwise, all the legal disputes and liabilities arising therefrom shall be borne by the exhibitors themselves.</div>
          <div>4. During the exhibition, all the complaints between exhibitors at NECC (Shanghai) shall be settled by the parties in principle. If they do not wish to negotiate or fail to reach an agreement, the intellectual property owner or the interested parties may file a complaint with the intellectual property office, make litigation at the people’s court or ask the department of administration for industry and commerce to handle the matter. The organizing committee has the responsibility to cooperate with the above authorities to obtain evidence.</div>
          <div>5. The organizing committee will abide by the principle of “friendly mediation, expert identification and coordinated ruling” to openly, fairly and impartially handle the cases of alleged infringement of intellectual property among all the exhibitors occurring at the exhibition site during the exhibition.</div>
          <div>6. For the institutions and persons affecting the order of the exhibition due to disputes arising from negotiating with the infringing party arbitrarily, the organizing committee and security office of the exhibition have the right to prohibit them from entering the hall or ask them to leave NECC (Shanghai)。</div>
          <div style="padding:10px 0 0"><el-checkbox v-model="xyCheckBox">Acknowledge and assume all legal consequences as stated above</el-checkbox></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipOk"  :disabled='!xyCheckBox'>Confirm and proceed to the Catalogue Entry submission page</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '../utils/tools.js';
import {validAddress,validComName,validComEName,validZipCode,validTel,validEmail, validateMobile } from '@/utils/validator'
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tagProps: {
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'childs'
      },
      saveBtnStatue:true,  //保存铵钮状态
      Dsave:true,  //暂存铵钮状态
      tagOptions: [],
      countryList: [],    //国家
      provinceList: [],  //省份
      cityList: [],    //城市
      form: {},
      rules: {},
      allList:[],
      isPC: true,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      dialogVisible:false,
      xyCheckBox:false,
      isClose:false,
      isBody:true,
      clgID:''
    }
  },

  components: {
    Upload
  },
  async mounted() {
    this.getsaasfield()
    this.getCountrys()
    this.getallprovinces()
    this.getStype()
  },
  methods: {
    tipOk(){
      if(this.xyCheckBox){
        this.dialogVisible = false
      }
      
    },
    validateProvince (rule, value, callback) {
      if (rule.required) { // 如果省份必填
        if (this.form.clgCountry === 'China' || this.form.clgCountry === undefined) { // 已选择中国或没有国家选项
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateCity (rule, value, callback) {
      if (rule.required) {
        if (this.form.clgProvince) {
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
     validateclgName (rule, value, callback) {
       if(value || rule.required){
          if (!validComName(value)) {
           callback(new Error(rule.message))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
    validateclgEName (rule, value, callback) {
       if(value || rule.required){
          if (!validComEName(value)) {
           callback(new Error(rule.message))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
     validateclgSName (rule, value, callback) {
       if(value || rule.required){
          if (value.length > 50) {
           callback(new Error('公司简称长度不能超过50字符！'))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
    validateclgESName (rule, value, callback) {
       if(value || rule.required){
          if (value.length > 50) {
           callback(new Error('公司简称长度不能超过50字符！'))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
     validateclgZipCode(rule, value, callback) {
      if(value || rule.required){
        if (!validZipCode(value)) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
      }else{
         callback()
       }
 
    },
    validateEmail (rule, value, callback) {
      if(value || rule.required){
        if (!validEmail(value)) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      }else{
        callback()
      }
    },

   validateAddress  (rule, value, callback) {
     if(value || rule.required){
      if (!validAddress(value)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
     }else{
        callback()
     }
    },

   validateTel  (rule, value, callback) {
     if(value || rule.required){
      if (!validTel(value)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
      }else{
        callback()
      }
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        clgCountry: [{ required: item.required, trigger: 'change', message: 'Please choose '+item.fieldName}],
        clgProvince:[{ required: item.required, trigger: 'change', message: 'Please choose '+item.fieldName,validator: this.validateProvince}],
        clgCity:[{ required: item.required, trigger: 'change', message: 'Please choose '+item.fieldName,validator: this.validateCity}],
        clgZipCode: [{ required: item.required, trigger: 'change',  message: "Enter correctly"+item.fieldName, validator: this.validateclgZipCode }],
        clgAddress: [{ required: item.required, trigger: 'change',  message: item.fieldName+' enter 6-200 characters', validator: this.validateAddress }],
        clgLogo: [{ required: item.required, trigger: 'change',  message:item.fieldName}],
        clgFax: [{ required: item.required, trigger: 'change', message: "Enter correctly"+item.fieldName,validator: this.validateTel}],
        clgTel: [{ required: item.required, trigger: 'change', message: "Enter correctly"+item.fieldName,validator: this.validateTel}],
        clgMobile: [{ required: item.required, trigger: 'change', message: "Enter correctly"+item.fieldName, validator: validateMobile }],
        clgComName: [{ required: item.required, trigger: 'change',message: item.fieldName+'Enter 2-200 characters', validator: this.validateclgName }],
        clgComEName: [{ required: item.required, trigger: 'change',message: item.fieldName+'Enter 2-200 characters', validator: this.validateclgEName }],
        clgComSName: [{ required: item.required, trigger: 'change',message: item.fieldName+' enter within 100 characters', validator: this.validateclgSName }], // 公司中文简称
        clgComESName: [{ required: item.required, trigger: 'change',message: item.fieldName+' enter within 100 characters', validator: this.validateclgESName }], // 公司英文简称
        other:{required:item.required, message: item.fieldName+'Cannot be empty', trigger: 'change'},
        clgEmail: [{ required: item.required, trigger: 'change', message: "Enter correctly"+item.fieldName, validator: this.validateEmail}],
      }
      switch (item.fieldKey){
        case 'clgCountry':
        case 'clgProvince':
        case 'clgCity':
        case 'clgEmail':
        case 'clgZipCode':
        case 'clgComName':
        case 'clgComEName':
        case 'clgComSName':
        case 'clgComESName':
        case 'clgTel':
        case 'clgMobile':
        case 'clgFax':
        case 'clgLogo':
            temp = item.fieldKey
            break;
        case 'clgAddress':
        case 'clgEAddress':
            temp = 'clgAddress'
            break;
        default: 
            temp = 'other'
            break
      }
      return rulesData[temp]
    },
    getsaasfield(){
      api.getsaasfield({type:"catalog"}).then(res => {
        if (res.data.code === 200) {
           this.allList =[]
            var _data = res.data.data
          for(var i = 0;i<_data.length;i++){
              if(_data[i].enable == 1){
                this.allList.push(_data[i])
              }
          }
          for(var j=0;j<this.allList.length;j++){
            this.$set( this.form,this.allList[j].fieldKey,"")
          }
          this.$nextTick(() => {
              this.getData()
          })
        }
      })
    },

    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.form[val] = this.form[val].replace(/[^\d]/g,'');
    },
    getClass(arr,val){
      var temp = [];
      function getSelectVal(_arr,_id){
        for(var i=0;i<_arr.length;i++){
          if(_arr[i].childs && _arr[i].childs.length>0){
              getSelectVal(_arr[i].childs,_id)
          }
          if(_arr[i].id == _id){
            var _temp = []
            if(_arr[i].gpId){
              _temp.push(_arr[i].gpId)
            }
            if(_arr[i].pId){
              _temp.push( parseInt(_arr[i].pId))
            }
            _temp.push(_arr[i].id)
            temp.push(_temp)
          }
        }
      }
      getSelectVal(arr,val)
      return temp
    },
    //获取主营产品分类  并且赋值
    getStype(val){
      api.getexhibitstype().then((res) => {
        this.tagOptions = this.removeEmptyChild(res.data.data)
        var select = []
        if(val && val !='' ){
            select = val.split(",")
        }
        if(select.length>0){
          var _temp = []
          for(var j=0;j<select.length;j++){
            _temp.push( ...this.getClass(this.tagOptions,select[j]) )
          }
          this.form.clgPdtType =  _temp
        }
      })
    },
    //获取国家选项
    getCountrys() {
      api.getallcountrys({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        this.countryList = [{zptArea: "国内",zptECity: "China"}, ...res.data.data]
      })
    },
    //国家切换
    changeCountry(){
      if(this.form.clgCountry !='China'){
          this.form.clgProvince= ''
          this.form.clgCity =''
          this.cityList =[]
          this.provinceList =[]
      }else{
        api.getallprovinces().then((res) => {
          this.provinceList = res.data.data
        })
        this.getCity()
      }
    },
    //切换省份
    changeProvince(){
      this.form.clgCity =''
      this.getCity()
    
    },
    //跟据省份获取城市
    getCity(){
      if( this.form.clgProvince && this.form.clgProvince !=""){
          api.getallcitysbyprovince({zptProvince:this.form.clgProvince}).then((res)=>{
              this.cityList = res.data.data
          })
      }else{
          this.cityList = []
      }
    },
    // 获取所有省份
    getallprovinces() {
      api.getallprovinces().then((res) => {
        this.provinceList = res.data.data
      })
    },
    //获取会刊信息
    getData(){
      return new Promise((resolve, reject)=>{
        api.getcatalogdetail().then((res)=>{
          if(res.data.code =='200' && res.data.data){
            var _data = res.data.data
            this.clgID = res.data.data.clgID
            for (let i in this.form) {
              this.form[i] = _data[i]?''+_data[i]+'':''
            }
            this.form = JSON.parse(JSON.stringify(this.form))
            if(this.form.hasOwnProperty("clgPdtType")  ){
              this.getStype(this.form.clgPdtType) 
            }
            api.getallcountrys().then((res) => {      
              this.countryList = [{zptArea: "国内",zptECity: "China"}, ...res.data.data]
            })
            if ((this.form.clgCountry && this.form.clgCountry === 'China') || this.form.atrCountry===undefined) {
              this.getallprovinces()
              this.getCity()
            }else{
              this.provinceList = [];
              this.citysList= [];
            }
            if (_data.clgSysState === '正常') {
              this.Dsave = true
            } else {
              this.Dsave = false
            }
            this.saveBtnStatue = false
            resolve(_data.clgPdtType)
          }else{
            this.dialogVisible = true
            this.form.clgComEName = this.userInfo.atrEName
            this.form.clgComName = this.userInfo.atrName
            this.saveBtnStatue = false
            this.Dsave = false
            // this.pullcatalog()
            reject("")
          }
        })
      })
    },
    pullcatalog(){
      // console.log(this.form)
      if(this.clgID !=''){
        this.$notify({
          title: 'Previous catalogue information already exists',
          type: 'success',
          duration: 2000
        })
        return false
      }
      return new Promise((resolve, reject)=>{
            api.pullcatalog().then((res)=>{
                if(res.data.code =='200'){
                    this.getData()
                    resolve(_data.clgPdtType)
                }else{
                  // reject("")
                }
            })
      })
    },

    onSubmit(IsCache) {
        if( this.saveBtnStatue ){
          return false
        }
        for (let i in this.form) {
          if( typeof this.form[i] != 'object'){
            this.form[i] = (this.form[i]).toString().replace(/^\s+|\s+$/g,"")
          }
        }
        this.$refs['magezineForm'].validate((valid) => {
          if (valid) {
              var paramt = JSON.parse(JSON.stringify(this.form))
              var tempArry = []
              if (paramt.clgPdtType) {
                for(var i=0;i<paramt.clgPdtType.length;i++){
                  var _arr = paramt.clgPdtType[i]
                  tempArry.push( _arr[_arr.length-1])
                }
                paramt.clgPdtType = tempArry.join(",")
              }
              paramt.clgBthCode =  JSON.parse(localStorage.getItem('userInfo')).bthCode
              paramt.IsCache = IsCache
              this.saveBtnStatue = true
              api.savecatalog(paramt).then((res) => {
                if (res.data.code === 200) {
                  if(IsCache === ""){
                    this.$confirm('<span style="font-size:18px">Continue to submit main product</span>', '', {
                      confirmButtonText: 'Ok',
                      type: 'none',
                      showCancelButton:false,
                      closeOnClickModal:false,
                      closeOnPressEscape:false,
                      dangerouslyUseHTMLString:true,
                      showClose:false,
                      center: true
                    }).then(() => {
                      this.$router.push(`/product`)
                    })
                  }
                  this.$notify({
                    title: 'Submitted successfully',
                    type: 'success',
                    duration: 2000
                  })

                }
                this.saveBtnStatue = false
              })
          } else {
            // this.$notify({
            //   title: 'Please check if the form filling items meet the specifications!',
            //   type: 'error'
            // })
            return false
          }
        })
    },
    // 因后端API不支持，需前端处理数据结构，仅支持三级，写死去掉最后childs为空的属性
    removeEmptyChild(data) {
      let types = data.map((element) => {
        if (element.childs.length === 0) {
          delete element.childs
        } else {
          element.childs.map((item) => {
            if (item.childs.length === 0) {
              delete item.childs
            } else {
              item.childs.map((_item) => {
                if (_item.childs && _item.childs.length === 0) {
                  delete _item.childs
                }
                return _item
              })
            }
            return item
          })
        }
        return element
      })
      return types
    }
  }
}
</script>
<style lang="less">
.magezine{
  .el-form-item.is-error .clearError input.el-input__inner{
    border: 1px solid #DCDFE6 !important;
  }
  .blue {
    color: #409eff;
  }

  .title {
    margin-bottom: 30px;
  }

  .col-1-fix {
    padding-left: 0 !important;
  }
}
.tipContent div{
  font-size:14px;
  line-height: 30px;
}
.clgLogo .el-form-item__label{
  position: relative;
}
.clgLogo .el-form-item__label::after{
  content:'(the logo will be used for the company invitation card)';
  position: absolute;
  right: 10px;
  top:34px;
  line-height:20px
}
@media screen and (max-width:540px){
  .magezine{
    .el-form-item__error{
      width: 100%;
      text-align: right;
    }
    .el-form-item__label{
      font-size:14px;
    }
    .el-input__inner{
      border:0;
      text-align: right;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:180px;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width:10px;
    }
    .cccItem{
      border:0;
      margin:0;
      .el-form-item__error{
        top: 240%
      }
    }
    .pad0{
      padding-right:0 !important;
    }
    .telOrFax{
      padding:0 24px;
      .el-input__inner{
        padding:0;
        border: 1px solid #ededed;
        text-align: center;
      }
    }
  }
}
</style>
